import React, { createContext, useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import { connectSocket, disconnectSocket } from "@via/utils/socket";
import { SocketEvents } from "common";

interface SocketContextType {
  socket: Socket | null;
}

const SocketContext = createContext<SocketContextType>({ socket: null });

const SocketProvider: React.FC<{
  children: React.ReactNode;
  socketUri: string;
}> = ({ children, socketUri }) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    // Connect socket
    const newSocket = connectSocket(socketUri);
    setSocket(newSocket);

    // common listeners
    newSocket.on(SocketEvents.Connect, () => {});
    newSocket.on(SocketEvents.Disconnect, () => {});

    return () => {
      // Disconnect socket
      newSocket.off(SocketEvents.Connect);
      newSocket.off(SocketEvents.Disconnect);
      disconnectSocket(socketUri);
    };
  }, [socketUri]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export { SocketContextType, SocketProvider, SocketContext };
